// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2s44e","left":"styles_left__1hNRN"};